import { render } from "./VFieldGroup.vue?vue&type=template&id=64621b93&ts=true"
import script from "./VFieldGroup.vue?vue&type=script&lang=ts"
export * from "./VFieldGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__